var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Layer_1",
    width: 144.945,
    height: 83.328,
    viewBox: "0 0 144.945 83.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#f4a100}.prefix__cls-2{fill:#e84810}.prefix__cls-3{fill:#790954}.prefix__cls-4{fill:#63a330}.prefix__cls-5{fill:#28225a}.prefix__cls-6{fill:#00958f}.prefix__cls-7{fill:#939191}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6915",
    "data-name": "Group 6915"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2495",
    d: "M118.208 107.934a7.271 7.271 0 0 1 .2-1.734 11.6 11.6 0 0 0-.734 1.2 20.819 20.819 0 0 1-5.27 6.27 40.139 40.139 0 0 1-7.2 3.869 22.758 22.758 0 0 0 2.868-.4 35.177 35.177 0 0 0 11.207-5.537 5.715 5.715 0 0 1-1.071-3.668z",
    className: "prefix__cls-1",
    "data-name": "Path 2495",
    transform: "translate(-61.116 -55.091)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6906",
    "data-name": "Group 6906",
    transform: "translate(46.218 8.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2496",
    d: "M114.5 46.3a27.246 27.246 0 0 1 2.268 3.8 44.708 44.708 0 0 1 5.2 6.07c-.133-.467-.334-.934-.467-1.4a27.692 27.692 0 0 0-7.001-8.47z",
    className: "prefix__cls-1",
    "data-name": "Path 2496",
    transform: "translate(-110.431 -43.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2497",
    d: "M121.2 63.638a6.682 6.682 0 0 1 2.6-.467 4.4 4.4 0 0 1 .934.067A40.193 40.193 0 0 0 119.6 56.1a27.549 27.549 0 0 1 1.6 7.538z",
    className: "prefix__cls-1",
    "data-name": "Path 2497",
    transform: "translate(-112.129 -46.427)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2498",
    d: "M120.673 53.007a22.648 22.648 0 0 0 1.267 3.469c.067.2.133.334.2.534.334.6.667 1.2 1 1.734a5.942 5.942 0 0 1 3.135 3 7.02 7.02 0 0 1 3.4-2.868 36.677 36.677 0 0 0-9.072-12.541A24.693 24.693 0 0 0 110.6 41.6a13.339 13.339 0 0 1 1.267 1.468 28.606 28.606 0 0 1 8.806 9.939z",
    className: "prefix__cls-1",
    "data-name": "Path 2498",
    transform: "translate(-109.132 -41.6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2499",
    d: "M117.205 108.4h-3.535l-.6 1.6c-.8 2.268-2.735 4.136-4.67 6a31.38 31.38 0 0 0 4.269-2.535 16.182 16.182 0 0 0 4.536-5.065z",
    className: "prefix__cls-1",
    "data-name": "Path 2499",
    transform: "translate(-108.4 -63.84)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6907",
    "data-name": "Group 6907",
    transform: "translate(27.073 7.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2500",
    d: "M106.516 59.076c.067 0 .2.067.267.067a22.24 22.24 0 0 0-6.337-9.339 20.943 20.943 0 0 0-2.935-2c-.934-.6-1.935-1.2-3.069-2.068A29.525 29.525 0 0 0 84.7 43c-1.067.6-2 1.334-2.8 1.734-.734.4-1.468.867-2.2 1.334a21.523 21.523 0 0 1 9.673 0c3.535 1.267 8.672 1.734 11.34 5.337.734 1.6 2.668 3.6 4.6 5.6a13.649 13.649 0 0 1 1.203 2.071z",
    className: "prefix__cls-2",
    "data-name": "Path 2500",
    transform: "translate(-79.7 -41.363)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2501",
    d: "M109.968 41.467a11.312 11.312 0 0 0-1.468-.267c.934.534 1.868 1.134 2.735 1.734-.4-.467-.8-.934-1.267-1.467z",
    className: "prefix__cls-2",
    "data-name": "Path 2501",
    transform: "translate(-89.288 -40.763)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2502",
    d: "M107.875 44.384a30.843 30.843 0 0 0-5.6-3.6 36.73 36.73 0 0 0-7.671-.067 26.7 26.7 0 0 1 15.543 7.471 27.244 27.244 0 0 0-2.272-3.804z",
    className: "prefix__cls-2",
    "data-name": "Path 2502",
    transform: "translate(-84.661 -40.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2503",
    d: "M100.774 47.068a30.686 30.686 0 0 1 3 2.068 23.048 23.048 0 0 1 6.671 10.073 3.253 3.253 0 0 1 .467-.2 28.573 28.573 0 0 0-1.6-7.6c-5.136-5.67-12.207-9.806-20.746-9.139H88.5A27.7 27.7 0 0 1 97.706 45a17.7 17.7 0 0 0 3.068 2.068z",
    className: "prefix__cls-2",
    "data-name": "Path 2503",
    transform: "translate(-82.63 -41.094)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6908",
    "data-name": "Group 6908",
    transform: "translate(23.271 50.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2504",
    d: "M95.813 111.17a39.252 39.252 0 0 0 5-3.936 1.841 1.841 0 0 1-1.134-1.734v-.2a25.822 25.822 0 0 1-12.207 6.537A24.1 24.1 0 0 1 74 110.1c1.134 1 2.268 1.935 3.4 2.868a25.056 25.056 0 0 0 18.413-1.798z",
    className: "prefix__cls-3",
    "data-name": "Path 2504",
    transform: "translate(-74 -105.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2505",
    d: "M95.9 117.806c1 .133 1.935.267 2.935.334a26.671 26.671 0 0 0 5.47-2.135c1.935-1.868 3.869-3.736 4.669-6l.6-1.6a26.3 26.3 0 0 1-13.674 9.401z",
    className: "prefix__cls-3",
    "data-name": "Path 2505",
    transform: "translate(-81.291 -106.332)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2506",
    d: "M103.781 108.4h-.2a44 44 0 0 1-5.337 4.269 25.111 25.111 0 0 1-11.607 2.868 28.021 28.021 0 0 1-6.137-.737 1.455 1.455 0 0 1 .334.267c2.335.867 4.736 1.668 7.071 2.535.534 0 1 .067 1.468.067a26.814 26.814 0 0 0 14.408-9.269z",
    className: "prefix__cls-3",
    "data-name": "Path 2506",
    transform: "translate(-76.164 -106.332)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6909",
    "data-name": "Group 6909",
    transform: "translate(.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2507",
    d: "M79.21 36.4A24.018 24.018 0 0 0 62 43.6c.067-.067.133-.067.267-.133a28.6 28.6 0 0 1 13.208-3.4c.133-.067.334-.067.467-.133a32.264 32.264 0 0 1 3.669-.734 21.937 21.937 0 0 1 4.2.067 32.684 32.684 0 0 1 7.671.067 27.958 27.958 0 0 0-8.869-2.734 29.964 29.964 0 0 0-3.403-.2z",
    className: "prefix__cls-4",
    "data-name": "Path 2507",
    transform: "translate(-47.182 -31.853)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2508",
    d: "M86.891 37.4c-3.869-4-8.138-6.871-13.275-7.4-5.136-.467-10.273-1-15.076 1.267a26.845 26.845 0 0 0-18.011 31.948A25.528 25.528 0 0 1 42 59.479a24.489 24.489 0 0 1 10.94-17.01 6.289 6.289 0 0 1 .66-.669 24.873 24.873 0 0 1 21.75-7.936 28.643 28.643 0 0 1 10.406 3.469c.467.067 1 .2 1.468.267a.713.713 0 0 1-.333-.2z",
    className: "prefix__cls-4",
    "data-name": "Path 2508",
    transform: "translate(-39.786 -29.583)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2509",
    d: "M44.3 65.042a27.118 27.118 0 0 1 3.4-4.936l.2-.867a57.878 57.878 0 0 1 4.939-7.739A23.79 23.79 0 0 0 44.3 65.042z",
    className: "prefix__cls-4",
    "data-name": "Path 2509",
    transform: "translate(-41.289 -36.88)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2510",
    d: "M58.772 46.3c-.667.334-1.267.734-1.935 1.134a42.279 42.279 0 0 0-6.137 9.007 27.891 27.891 0 0 1 5.2-4.469A30.149 30.149 0 0 1 67.977 43.3a25.335 25.335 0 0 0-9.205 3z",
    className: "prefix__cls-4",
    "data-name": "Path 2510",
    transform: "translate(-43.42 -34.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2511",
    d: "M76.775 43.134a34.029 34.029 0 0 1-3.6.734 27.725 27.725 0 0 0-9.472 5.8 13.147 13.147 0 0 1 5.337-2.4c.667-.067 1.267-.133 1.868-.2a21.085 21.085 0 0 1 3.469-1.134 24.121 24.121 0 0 1 2.2-1.334c.8-.4 1.734-1.067 2.8-1.734a7.25 7.25 0 0 0-1.2-.067 10.664 10.664 0 0 1-1.402.335z",
    className: "prefix__cls-4",
    "data-name": "Path 2511",
    transform: "translate(-47.748 -33.984)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6910",
    "data-name": "Group 6910",
    transform: "translate(0 33.632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2513",
    d: "M48.27 101.843c4.469 6.6 11.74 8.872 16.81 9.939a16.455 16.455 0 0 0 5.136-.067l-8.872-3.2a45.247 45.247 0 0 1-9.005-8.605 26.065 26.065 0 0 1-2.739-4.138 27.656 27.656 0 0 1-3.4-3.872 29.173 29.173 0 0 1-3-5.2c.067 1.668.267 3.269.4 4.87z",
    className: "prefix__cls-5",
    "data-name": "Path 2513",
    transform: "translate(-40.475 -82.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2514",
    d: "M57.8 105.134l.6.8a21.633 21.633 0 0 0 6.6 4c1.134.534 2.4 1.067 3.535 1.668a27.4 27.4 0 0 0 3.069 1c-1.134-.934-2.268-1.868-3.4-2.868-.867-.4-1.734-.8-2.668-1.334-1.935-.734-3.936-1.4-5.87-2.068-.867-.667-1.8-1.4-2.668-2.135.267.334.534.6.8.934z",
    className: "prefix__cls-5",
    "data-name": "Path 2514",
    transform: "translate(-45.069 -88.057)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2515",
    d: "M66.5 112.4a33.875 33.875 0 0 1-4.4-2.2 62.3 62.3 0 0 0 6.07 5.27l10.34 3.669c.2-.067.4-.067.667-.133a36 36 0 0 1 3.869-.667c.067 0 .133-.067.2-.067a10.808 10.808 0 0 0-1.468-.067c-2.335-.867-4.736-1.668-7.071-2.535a1.455 1.455 0 0 1-.334-.267 39.25 39.25 0 0 1-4.336-1.267c-1.2-.667-2.4-1.201-3.537-1.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2515",
    transform: "translate(-46.767 -90.054)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2516",
    d: "M74.526 110.552a23.439 23.439 0 0 1-3.669-.334h-.067l-.867-.334a24.527 24.527 0 0 1-3.869.4 15.874 15.874 0 0 1-2.4-.2c-5.27-1.134-12.608-3.4-17.21-10.206l-4.738-10.406c-.2-2.068-.467-4.2-.467-6.4A26.891 26.891 0 0 1 40.306 80a24.942 24.942 0 0 0 3.869 22.814c2.268 3.069 5.737 6.871 9.206 8.605a30.22 30.22 0 0 0 9.606 2.6c2.6.334 6.537 1.2 9.005 0 3.6-1.734 7-2.8 10.206-4.87a23.735 23.735 0 0 1-7.672 1.403z",
    className: "prefix__cls-5",
    "data-name": "Path 2516",
    transform: "translate(-39.115 -80)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2517",
    d: "M89 123.534a21.546 21.546 0 0 0 7.538-.6c-1-.067-1.935-.2-2.935-.334-.467.133-1 .334-1.534.467a24.372 24.372 0 0 0-3.069.467z",
    className: "prefix__cls-5",
    "data-name": "Path 2517",
    transform: "translate(-55.723 -94.183)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6911",
    "data-name": "Group 6911",
    transform: "translate(1.191 13.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2518",
    d: "M48.951 80.748a25.162 25.162 0 0 1 .067-13.875A28.608 28.608 0 0 1 54.755 56.2a30.616 30.616 0 0 0-5.2 4.469.506.506 0 0 0-.133.267l-2.138 11.007a18.9 18.9 0 0 0 1.667 8.805z",
    className: "prefix__cls-6",
    "data-name": "Path 2518",
    transform: "translate(-43.014 -51.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2519",
    d: "M45.27 74.673l2-10.273a27.118 27.118 0 0 0-3.4 4.936c-.2.867-.334 1.734-.467 2.668a34.588 34.588 0 0 0-.334 7.338 29.173 29.173 0 0 0 3 5.2 32.057 32.057 0 0 0 3.4 3.869c-.133-.267-.267-.467-.4-.734a23.749 23.749 0 0 1-3.799-13.004z",
    className: "prefix__cls-6",
    "data-name": "Path 2519",
    transform: "translate(-41.601 -54.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2520",
    d: "M57.029 85.222c-1.935-2-3.869-4-4.2-6.8-.534-4.536-1.067-8.272.534-12.608C55.962 58.472 58.7 52.4 66.368 49.2c-.6.067-1.267.133-1.868.2a13.147 13.147 0 0 0-5.337 2.4 28.076 28.076 0 0 0-8.138 13.075 24.013 24.013 0 0 0 3.736 21.013c.867.734 1.734 1.4 2.668 2.135 1.935.667 3.936 1.4 5.87 2.068-2.334-.867-4.335-2.868-6.27-4.869z",
    className: "prefix__cls-6",
    "data-name": "Path 2520",
    transform: "translate(-43.955 -49.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2521",
    d: "M41.834 81.2a30.3 30.3 0 0 1 .4-5.937c.067-.267.067-.6.133-.867a25.529 25.529 0 0 0-1.467 3.74 17.945 17.945 0 0 0 .934 3.064z",
    className: "prefix__cls-6",
    "data-name": "Path 2521",
    transform: "translate(-40.9 -57.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6912",
    "data-name": "Group 6912",
    transform: "translate(14.732 19.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2522",
    d: "M66.937 69c-1.334 0-5.737.467-5.737 6.6l.067 6c0 6.07 4.4 6.6 5.737 6.6s5.6-.467 5.737-6.4a.236.236 0 0 0-.267-.267h-2a.287.287 0 0 0-.267.267q-.2 4-3.2 4c-1.334 0-3.2-.467-3.2-4.67v-1.323h8.605a.287.287 0 0 0 .267-.267v-3.869C72.674 69.467 68.271 69 66.937 69zm-3.2 8.605v-1.667c0-4.069 1.8-4.536 3.2-4.536 2.135 0 3.2 1.534 3.2 4.536v1.668z",
    className: "prefix__cls-5",
    "data-name": "Path 2522",
    transform: "translate(-61.2 -62.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2523",
    d: "M96.443 69.1a4.692 4.692 0 0 0-4.469 2.8 4.939 4.939 0 0 0-8.472-.734l-.133-1.534a.287.287 0 0 0-.267-.267h-1.535a.287.287 0 0 0-.267.267v17.946a.287.287 0 0 0 .267.267h2a.287.287 0 0 0 .267-.267v-11.54q0-4.6 3.2-4.6c2.135 0 3.2 1.668 3.2 5.2v10.94a.287.287 0 0 0 .267.267h2a.287.287 0 0 0 .267-.267V75.1c.2-2.468 1.2-3.669 3.135-3.669 2.135 0 3.2 1.668 3.2 5.2v10.94a.287.287 0 0 0 .267.267h2a.287.287 0 0 0 .267-.267V75.7c.075-5.933-3.593-6.6-5.194-6.6z",
    className: "prefix__cls-5",
    "data-name": "Path 2523",
    transform: "translate(-67.892 -62.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2524",
    d: "M122.171 69.1a4.748 4.748 0 0 0-3.736 1.6l-.4-1.134c-.067-.133-.133-.2-.267-.2h-2.8a.287.287 0 0 0-.267.267v23.815a.287.287 0 0 0 .267.267h4a.287.287 0 0 0 .267-.267v-6.2a4.358 4.358 0 0 0 2.868.934c1.134 0 4.8-.467 4.8-6.6v-5.945c.138-6.07-3.598-6.537-4.732-6.537zM120.9 84.042c-.8 0-1.534-.334-1.534-4.4v-1.937c0-2.335.2-3.669.667-4.136a1.063 1.063 0 0 1 .8-.267c1 0 1.534.734 1.6 4.4v1.868c.067 4.139-.733 4.472-1.533 4.472z",
    className: "prefix__cls-5",
    "data-name": "Path 2524",
    transform: "translate(-79.012 -62.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2525",
    d: "M140.937 69.1c-2.935 0-6.137 1.734-6.137 6.6v5.937c0 4.87 3.135 6.6 6.137 6.6s6.137-1.734 6.137-6.6V75.7c0-4.866-3.135-6.6-6.137-6.6zm1.534 10.473c0 2.335-.2 3.6-.734 4.136a1.063 1.063 0 0 1-.8.267c-1 0-1.534-.667-1.6-4.4v-1.871c0-4.069.734-4.4 1.534-4.4.734 0 1.534.334 1.534 4.4v1.868z",
    className: "prefix__cls-5",
    "data-name": "Path 2525",
    transform: "translate(-85.704 -62.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2526",
    d: "M174.246 69.667a.245.245 0 0 0-.2-.067h-4.069c-.133 0-.267.067-.267.2l-2 11.14-2.069-11.14c0-.133-.133-.2-.267-.2h-3.4c-.133 0-.267.067-.267.2l-2.068 11.14L157.7 69.8c0-.133-.133-.2-.267-.2h-4.069c-.067 0-.133.067-.2.067a.245.245 0 0 0-.067.2l3.469 17.944c0 .133.133.2.267.2h4.936c.133 0 .267-.067.267-.2l1.668-8.672 1.668 8.672c0 .133.133.2.267.2h4.936c.133 0 .267-.067.267-.2l3.469-17.944a.245.245 0 0 0-.065-.2z",
    className: "prefix__cls-5",
    "data-name": "Path 2526",
    transform: "translate(-91.796 -62.396)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2527",
    d: "M196.807 81.441h-4a.287.287 0 0 0-.267.267c-.067 2.068-.867 2.335-1.534 2.335-.8 0-1.534-.267-1.534-3.069v-.6h7.338a.287.287 0 0 0 .267-.267V75.7c0-4.87-3.135-6.6-6.137-6.6s-6.137 1.734-6.137 6.6v5.87c0 4.87 3.135 6.6 6.137 6.6 2.935 0 6.137-1.668 6.137-6.471a.236.236 0 0 0-.267-.267zM190.87 73.3c.667 0 1.534.267 1.534 2.8v.734h-3.069V76.1c.001-2.464.735-2.8 1.535-2.8z",
    className: "prefix__cls-5",
    "data-name": "Path 2527",
    transform: "translate(-102.35 -62.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2528",
    d: "M213.338 69.1a5.666 5.666 0 0 0-4.4 2.068l-.6-1.6c-.067-.133-.133-.2-.267-.2h-2.8a.287.287 0 0 0-.267.267v17.943a.287.287 0 0 0 .267.267h4a.287.287 0 0 0 .267-.267v-9.939c0-3.069 1.134-4.4 3.736-4.4a.287.287 0 0 0 .267-.267v-3.6c.064-.139-.069-.272-.203-.272z",
    className: "prefix__cls-5",
    "data-name": "Path 2528",
    transform: "translate(-109.075 -62.229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2529",
    d: "M224.237 69c-1.334 0-5.737.467-5.737 6.6l.067 6c0 6.07 4.4 6.6 5.737 6.6s5.6-.467 5.737-6.4a.236.236 0 0 0-.267-.267h-2a.287.287 0 0 0-.267.267q-.2 4-3.2 4c-1.334 0-3.2-.467-3.2-4.67v-1.323h8.605a.287.287 0 0 0 .267-.267v-3.869c-.005-6.204-4.408-6.671-5.742-6.671zm-3.137 8.605v-1.667c0-4.069 1.8-4.536 3.2-4.536 2.135 0 3.2 1.534 3.2 4.536v1.668z",
    className: "prefix__cls-5",
    "data-name": "Path 2529",
    transform: "translate(-113.57 -62.196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2530",
    d: "M249.574 58.8h-2a.287.287 0 0 0-.267.267v8.272a4.474 4.474 0 0 0-3.737-1.739c-1.6 0-5.27.667-5.27 6.6v5.937c0 5.937 3.669 6.6 5.27 6.6a4.764 4.764 0 0 0 4.069-2.068l.133 1.534a.287.287 0 0 0 .267.267h1.534a.287.287 0 0 0 .267-.267V59.067a.287.287 0 0 0-.266-.267zM244.1 82.348c-1.4 0-3.2-.534-3.2-5.2v-4q0-5.2 3.2-5.2c1.334 0 3.2.534 3.2 5.2v4c.005 4.666-1.862 5.2-3.2 5.2z",
    className: "prefix__cls-5",
    "data-name": "Path 2530",
    transform: "translate(-120.162 -58.8)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6913",
    "data-name": "Group 6913",
    transform: "translate(58.226 47.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2531",
    d: "M132.737 109.238l-.334-.067c-1.267-.334-3.2-.8-3.269-3.135a2.786 2.786 0 0 1 3.066-2.936c1.534 0 3.2 1 3.2 3.936a.287.287 0 0 0 .267.267h1.668a.287.287 0 0 0 .267-.267c0-4.536-2.8-6.137-5.4-6.137-1.267 0-5.337.4-5.337 5.27 0 3.869 3.135 4.736 5 5.27 2.335.667 3.669 1.468 3.669 3.669 0 2.735-1.868 3.335-3.469 3.335-1.668 0-3.469-1-3.469-3.869a.287.287 0 0 0-.267-.267l-1.668-.067a.236.236 0 0 0-.267.267c0 4.536 3.135 6.137 5.737 6.137 3.736 0 5.737-2 5.737-5.67-.061-3.001-1.595-4.735-5.131-5.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2531",
    transform: "translate(-126.4 -100.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2532",
    d: "M152.137 103.1c2 0 3.135 1.4 3.269 4.136v.4a.287.287 0 0 0 .267.267h1.734a.287.287 0 0 0 .267-.267v-.467c-.2-5.67-4-6.27-5.6-6.27-1.734 0-5.67.667-5.67 6.737v6.2c0 6.07 4 6.737 5.67 6.737 1.6 0 5.4-.6 5.6-6.337v-.4a.287.287 0 0 0-.267-.267h-1.734a.287.287 0 0 0-.267.267v.467c-.2 2.735-1.334 4.069-3.269 4.069-2.268 0-3.4-1.6-3.4-4.736v-5.8c-.002-3.136 1.198-4.736 3.4-4.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2532",
    transform: "translate(-133.059 -100.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2533",
    d: "M176.806 101.2h-1.734a.287.287 0 0 0-.267.267v8h-5.937v-8a.287.287 0 0 0-.267-.267h-1.734a.287.287 0 0 0-.267.267v18.745a.287.287 0 0 0 .267.267h1.733a.287.287 0 0 0 .267-.267v-8.472h5.933v8.539a.287.287 0 0 0 .267.267h1.734a.287.287 0 0 0 .267-.267v-18.745a.305.305 0 0 0-.262-.334z",
    className: "prefix__cls-5",
    "data-name": "Path 2533",
    transform: "translate(-139.784 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2534",
    d: "M190.97 100.9c-1.734 0-5.67.667-5.67 6.737v6.27c0 6.07 4 6.737 5.67 6.737 5.337 0 5.737-5.136 5.737-6.737v-6.27c0-1.601-.4-6.737-5.737-6.737zm0 2.2c2.268 0 3.4 1.668 3.4 4.736v5.8c0 3.135-1.2 4.736-3.4 4.736-2.268 0-3.4-1.6-3.4-4.736v-5.8c-.002-3.136 1.13-4.736 3.4-4.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2534",
    transform: "translate(-146.009 -100.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2535",
    d: "M210.67 100.9c-1.734 0-5.67.667-5.67 6.737v6.27c0 6.07 4 6.737 5.67 6.737 5.337 0 5.737-5.136 5.737-6.737v-6.27c0-1.601-.4-6.737-5.737-6.737zm0 2.2c2.268 0 3.4 1.668 3.4 4.736v5.8c0 3.135-1.2 4.736-3.4 4.736-2.268 0-3.4-1.6-3.4-4.736v-5.8c-.002-3.136 1.13-4.736 3.4-4.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2535",
    transform: "translate(-152.568 -100.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2536",
    d: "M233.2 118.277h-5.937v-16.81a.287.287 0 0 0-.263-.267h-1.734a.287.287 0 0 0-.267.267v18.745a.287.287 0 0 0 .267.267h7.934a.287.287 0 0 0 .267-.267v-1.668a.287.287 0 0 0-.267-.267z",
    className: "prefix__cls-5",
    "data-name": "Path 2536",
    transform: "translate(-159.227 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2537",
    d: "M245.537 109.238l-.334-.067c-1.267-.334-3.2-.8-3.269-3.135A2.786 2.786 0 0 1 245 103.1c1.534 0 3.2 1 3.2 3.936a.287.287 0 0 0 .267.267h1.668a.287.287 0 0 0 .267-.267c0-4.536-2.8-6.137-5.4-6.137-1.267 0-5.337.4-5.337 5.27 0 3.869 3.135 4.736 5 5.27 2.335.667 3.669 1.468 3.669 3.669 0 2.735-1.868 3.335-3.469 3.335-1.668 0-3.469-1-3.469-3.869a.287.287 0 0 0-.267-.267l-1.668-.067a.236.236 0 0 0-.267.267c0 4.536 3.135 6.137 5.737 6.137 3.736 0 5.737-2 5.737-5.67-.061-3.001-1.662-4.735-5.131-5.736z",
    className: "prefix__cls-5",
    "data-name": "Path 2537",
    transform: "translate(-163.954 -100.9)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_6914",
    "data-name": "Group 6914",
    transform: "translate(.791 73.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2538",
    d: "M42.168 148.2a4.644 4.644 0 0 1-1.668-.334c-.133-.067-.2-.133-.2-.267v-.133l.133-.267c.067-.133.133-.2.267-.2h.133a2.555 2.555 0 0 0 1.267.334c.467 0 .934-.2.934-.734 0-.4-.467-.6-1.067-.867-.734-.334-1.534-.734-1.534-1.6a1.621 1.621 0 0 1 1.8-1.534 3.585 3.585 0 0 1 1.4.334c.133.067.2.133.2.267v.067l-.067.267c-.067.133-.133.2-.267.2h-.133a3.568 3.568 0 0 0-1.067-.267.747.747 0 0 0-.8.667c0 .4.534.6 1.134.867.734.334 1.468.734 1.468 1.6a1.706 1.706 0 0 1-1.933 1.6z",
    className: "prefix__cls-7",
    "data-name": "Path 2538",
    transform: "translate(-40.3 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2539",
    d: "M51.436 147.27v.067c0 .133-.067.267-.2.267a4.983 4.983 0 0 1-1.334.2c-1.067 0-1.6-.467-1.6-1.468v-3.269h-.334a.287.287 0 0 1-.267-.267v-.2a.287.287 0 0 1 .267-.267h.332v-.667c0-.133.067-.2.2-.267l.467-.2h.133a.287.287 0 0 1 .267.267v.8h1.2a.287.287 0 0 1 .267.267v.2a.287.287 0 0 1-.267.267h-1.2v3.069c0 .467.267.734.867.734a4.927 4.927 0 0 0 .8-.133h.066c.133 0 .267.067.267.2z",
    className: "prefix__cls-7",
    "data-name": "Path 2539",
    transform: "translate(-42.764 -139.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2540",
    d: "M54.967 143.167a.287.287 0 0 1 .267-.267h.466a.287.287 0 0 1 .267.267v3.269a.992.992 0 0 0 1.134 1.134 1.706 1.706 0 0 0 1.267-.667v-3.736a.287.287 0 0 1 .267-.267h.465a.287.287 0 0 1 .267.267v4.8a.287.287 0 0 1-.267.267h-.334a.287.287 0 0 1-.267-.267l-.067-.267h-.067a2.487 2.487 0 0 1-1.534.6 1.691 1.691 0 0 1-1.935-1.8v-3.335z",
    className: "prefix__cls-7",
    "data-name": "Path 2540",
    transform: "translate(-45.161 -140.499)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2541",
    d: "M69.2 146.771a.287.287 0 0 1-.267.267H68.6a.3.3 0 0 1-.267-.2l-.133-.467h-.067a1.845 1.845 0 0 1-1.6.734c-1.4 0-2.335-1.134-2.335-2.8a2.508 2.508 0 0 1 2.4-2.8 2.253 2.253 0 0 1 1.4.4v-2.335a.287.287 0 0 1 .267-.267h.467a.287.287 0 0 1 .267.267v5.27a13.325 13.325 0 0 0 .2 1.935zm-1.2-3.936a1.963 1.963 0 0 0-1.2-.467c-.934 0-1.534.8-1.534 2s.534 2 1.4 2A1.422 1.422 0 0 0 68 145.3z",
    className: "prefix__cls-7",
    "data-name": "Path 2541",
    transform: "translate(-48.257 -139.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2542",
    d: "M78.269 147.136c.133 0 .2.067.267.2l.067.2v.067c0 .133-.067.2-.2.267a6.67 6.67 0 0 1-1.8.334 2.509 2.509 0 0 1-2.6-2.8 2.543 2.543 0 0 1 2.6-2.8 2.1 2.1 0 0 1 2.2 2.335v.4a.287.287 0 0 1-.267.267H75a1.612 1.612 0 0 0 1.6 1.734 3.706 3.706 0 0 0 1.536-.34c.064.136.064.136.133.136zM77.8 144.8a1.265 1.265 0 0 0-1.267-1.4A1.546 1.546 0 0 0 75 144.935h2.8z",
    className: "prefix__cls-7",
    "data-name": "Path 2542",
    transform: "translate(-51.52 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2543",
    d: "M88.2 144.468v3.332a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-3.269a.992.992 0 0 0-1.134-1.134 1.706 1.706 0 0 0-1.267.667v3.736a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267V143a.287.287 0 0 1 .267-.267h.336a.287.287 0 0 1 .267.267l.067.267h.066a2.3 2.3 0 0 1 1.534-.667 1.75 1.75 0 0 1 1.866 1.868z",
    className: "prefix__cls-7",
    "data-name": "Path 2543",
    transform: "translate(-54.782 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2544",
    d: "M96.269 147.27v.067c0 .133-.067.267-.2.267a4.983 4.983 0 0 1-1.334.2c-1.067 0-1.6-.467-1.6-1.468v-3.269h-.267a.287.287 0 0 1-.267-.267v-.2a.287.287 0 0 1 .267-.267h.332v-.667c0-.133.067-.2.2-.267l.467-.2H94a.287.287 0 0 1 .267.267v.8h1.2a.287.287 0 0 1 .267.267v.2a.287.287 0 0 1-.267.267H94.2v3.069c0 .467.267.734.867.734a4.927 4.927 0 0 0 .8-.133h.067c.133 0 .267.067.267.2z",
    className: "prefix__cls-7",
    "data-name": "Path 2544",
    transform: "translate(-57.712 -139.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2545",
    d: "M101.368 148.2a4.644 4.644 0 0 1-1.668-.334c-.133-.067-.2-.133-.2-.267v-.133l.133-.267c.067-.133.133-.2.267-.2h.133a2.555 2.555 0 0 0 1.267.334c.467 0 .934-.2.934-.734 0-.4-.467-.6-1.067-.867-.734-.334-1.534-.734-1.534-1.6a1.621 1.621 0 0 1 1.8-1.534 3.585 3.585 0 0 1 1.4.334c.133.067.2.133.2.267v.067l-.067.267c-.067.133-.133.2-.267.2h-.133a3.568 3.568 0 0 0-1.067-.267.747.747 0 0 0-.8.667c0 .4.534.6 1.134.867.734.334 1.468.734 1.468 1.6-.001 1.136-.933 1.6-1.933 1.6z",
    className: "prefix__cls-7",
    "data-name": "Path 2545",
    transform: "translate(-60.009 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2546",
    d: "M116 142.767a.287.287 0 0 1 .267.267v5.67c0 1.134-.934 1.868-2.268 1.868a9.688 9.688 0 0 1-1.868-.267c-.133-.067-.2-.133-.2-.267v-.067c0-.133.067-.2.067-.267.067-.133.133-.2.267-.2h.067a6.225 6.225 0 0 0 1.468.267c.934 0 1.334-.4 1.334-1v-1.134a2.133 2.133 0 0 1-1.267.467 2.35 2.35 0 0 1-2.468-2.6 2.518 2.518 0 0 1 2.468-2.8 2.471 2.471 0 0 1 1.468.467v-.133a.287.287 0 0 1 .267-.267h.4zm-.8 1.2a1.963 1.963 0 0 0-1.2-.467c-.934 0-1.534.8-1.534 2s.6 1.8 1.534 1.8a1.333 1.333 0 0 0 1.2-.6z",
    className: "prefix__cls-7",
    "data-name": "Path 2546",
    transform: "translate(-63.971 -140.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2547",
    d: "M125.469 147.136c.133 0 .2.067.267.2l.067.2v.067c0 .133-.067.2-.2.267a6.67 6.67 0 0 1-1.8.334 2.509 2.509 0 0 1-2.6-2.8 2.543 2.543 0 0 1 2.6-2.8 2.1 2.1 0 0 1 2.2 2.335v.4a.287.287 0 0 1-.267.267H122.2a1.612 1.612 0 0 0 1.6 1.734 3.706 3.706 0 0 0 1.534-.334c.066.13.135.13.135.13zm-.4-2.335a1.265 1.265 0 0 0-1.267-1.4 1.546 1.546 0 0 0-1.534 1.534h2.8z",
    className: "prefix__cls-7",
    "data-name": "Path 2547",
    transform: "translate(-67.234 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2548",
    d: "M135.4 144.468v3.332a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-3.269a.992.992 0 0 0-1.134-1.134 1.706 1.706 0 0 0-1.267.667v3.736a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.264-.267V143a.287.287 0 0 1 .267-.267h.334a.287.287 0 0 1 .267.267l.067.267H132a2.3 2.3 0 0 1 1.534-.667 1.75 1.75 0 0 1 1.866 1.868z",
    className: "prefix__cls-7",
    "data-name": "Path 2548",
    transform: "translate(-70.497 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2549",
    d: "M144.369 147.136c.133 0 .2.067.267.2l.067.2v.067c0 .133-.067.2-.2.267a6.67 6.67 0 0 1-1.8.334 2.509 2.509 0 0 1-2.6-2.8 2.543 2.543 0 0 1 2.6-2.8 2.1 2.1 0 0 1 2.2 2.335v.4a.287.287 0 0 1-.267.267H141.1a1.612 1.612 0 0 0 1.6 1.734 3.706 3.706 0 0 0 1.534-.334c.066.13.135.13.135.13zm-.4-2.335a1.265 1.265 0 0 0-1.267-1.4 1.546 1.546 0 0 0-1.534 1.534h2.8z",
    className: "prefix__cls-7",
    "data-name": "Path 2549",
    transform: "translate(-73.526 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2550",
    d: "M150.767 143.367h.133a2.125 2.125 0 0 1 1.4-.667 3.9 3.9 0 0 1 .867.133c.133.067.2.133.2.267v.067l-.133.4c-.067.133-.133.2-.267.2h-.133a1.739 1.739 0 0 0-.734-.2 1.831 1.831 0 0 0-1.2.667v3.6a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-4.8a.287.287 0 0 1 .267-.267h.267a.287.287 0 0 1 .267.267z",
    className: "prefix__cls-7",
    "data-name": "Path 2550",
    transform: "translate(-76.789 -140.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2551",
    d: "M160.1 147.47h-.067a2.03 2.03 0 0 1-1.6.734c-1.4 0-2.335-1.067-2.335-2.8a2.509 2.509 0 0 1 2.4-2.8 2.974 2.974 0 0 1 1.6.467l.067-.2a.287.287 0 0 1 .267-.267h.267a.287.287 0 0 1 .267.267v2.929a13.357 13.357 0 0 0 .2 1.868v.067a.287.287 0 0 1-.267.267h-.334a.3.3 0 0 1-.267-.2zm-.2-3.535a2.275 2.275 0 0 0-1.267-.467c-.934 0-1.534.8-1.534 2s.534 1.934 1.4 1.934a1.506 1.506 0 0 0 1.334-1.067v-2.4z",
    className: "prefix__cls-7",
    "data-name": "Path 2551",
    transform: "translate(-78.853 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2552",
    d: "M169.336 147.27v.067c0 .133-.067.267-.2.267a4.983 4.983 0 0 1-1.334.2c-1.067 0-1.6-.467-1.6-1.468v-3.269h-.334a.287.287 0 0 1-.267-.267v-.2a.287.287 0 0 1 .267-.267h.334v-.667c0-.133.067-.2.2-.267l.467-.2H167a.287.287 0 0 1 .267.267v.8h1.2a.287.287 0 0 1 .267.267v.2a.287.287 0 0 1-.267.267h-1.2v3.069c0 .467.267.734.867.734a4.927 4.927 0 0 0 .8-.133H169c.133 0 .267.067.267.2z",
    className: "prefix__cls-7",
    "data-name": "Path 2552",
    transform: "translate(-82.016 -139.933)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2553",
    d: "M173.8 141.034c-.4 0-.6-.2-.6-.534a.6.6 0 1 1 1.2 0 .545.545 0 0 1-.6.534zm-.267 6.2a.287.287 0 0 1-.267-.267v-4.8a.287.287 0 0 1 .267-.267H174a.287.287 0 0 1 .267.267v4.8a.287.287 0 0 1-.267.267z",
    className: "prefix__cls-7",
    "data-name": "Path 2553",
    transform: "translate(-84.546 -139.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2554",
    d: "M182.3 144.468v3.332a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-3.269a.992.992 0 0 0-1.134-1.134 1.706 1.706 0 0 0-1.267.667v3.736a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267V143a.287.287 0 0 1 .267-.267h.334a.287.287 0 0 1 .267.267l.067.267h.067a2.3 2.3 0 0 1 1.534-.667 1.75 1.75 0 0 1 1.867 1.868z",
    className: "prefix__cls-7",
    "data-name": "Path 2554",
    transform: "translate(-86.111 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2555",
    d: "M191.569 142.767a.287.287 0 0 1 .267.267v5.67c0 1.134-.934 1.868-2.268 1.868a9.688 9.688 0 0 1-1.868-.267c-.133-.067-.2-.133-.2-.267v-.067c0-.133.067-.2.067-.267.067-.133.133-.2.267-.2h.067a6.225 6.225 0 0 0 1.468.267c.934 0 1.334-.4 1.334-1v-1.134h-.067a2.133 2.133 0 0 1-1.267.467 2.35 2.35 0 0 1-2.468-2.6 2.518 2.518 0 0 1 2.468-2.8 2.471 2.471 0 0 1 1.468.467v-.133a.287.287 0 0 1 .267-.267h.467zm-.8 1.2a1.963 1.963 0 0 0-1.2-.467c-.934 0-1.534.8-1.534 2s.6 1.8 1.534 1.8a1.333 1.333 0 0 0 1.2-.6z",
    className: "prefix__cls-7",
    "data-name": "Path 2555",
    transform: "translate(-89.107 -140.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2556",
    d: "M205.1 147.169c.133 0 .2.067.267.2l.067.267v.067c0 .133-.067.2-.2.267a3.706 3.706 0 0 1-1.534.334 2.509 2.509 0 0 1-2.6-2.8 2.543 2.543 0 0 1 2.6-2.8 3.957 3.957 0 0 1 1.534.334c.133.067.2.133.2.267v.067l-.067.267c-.067.133-.133.2-.267.2h-.133a3.51 3.51 0 0 0-1.2-.267c-1 0-1.6.734-1.6 2 0 1.2.6 2 1.6 2a3.186 3.186 0 0 0 1.2-.267c.069-.136.133-.136.133-.136z",
    className: "prefix__cls-7",
    "data-name": "Path 2556",
    transform: "translate(-93.835 -140.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2557",
    d: "M214.5 146.8a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-3.269a.992.992 0 0 0-1.134-1.134 1.518 1.518 0 0 0-1.267.667v3.736a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267v-7.138a.287.287 0 0 1 .267-.267h.467a.287.287 0 0 1 .267.267v2.6a2.353 2.353 0 0 1 1.468-.6 1.691 1.691 0 0 1 1.934 1.8v3.338z",
    className: "prefix__cls-7",
    "data-name": "Path 2557",
    transform: "translate(-96.831 -139.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2558",
    d: "M223.3 147.47h-.067a2.03 2.03 0 0 1-1.6.734c-1.4 0-2.335-1.067-2.335-2.8a2.509 2.509 0 0 1 2.4-2.8 2.974 2.974 0 0 1 1.6.467l.067-.2a.287.287 0 0 1 .267-.267h.267a.287.287 0 0 1 .267.267v2.929a13.357 13.357 0 0 0 .2 1.868v.067a.287.287 0 0 1-.267.267h-.334a.3.3 0 0 1-.267-.2zm-.2-3.535a2.275 2.275 0 0 0-1.267-.467c-.934 0-1.534.8-1.534 2s.534 1.934 1.4 1.934a1.506 1.506 0 0 0 1.334-1.067v-2.4z",
    className: "prefix__cls-7",
    "data-name": "Path 2558",
    transform: "translate(-99.894 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2559",
    d: "M234 144.468v3.332a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.266-.267v-3.269a.992.992 0 0 0-1.134-1.134 1.706 1.706 0 0 0-1.267.667v3.736a.287.287 0 0 1-.267.267h-.467a.287.287 0 0 1-.267-.267V143a.287.287 0 0 1 .267-.267h.334a.287.287 0 0 1 .267.267l.067.267h.067a2.3 2.3 0 0 1 1.534-.667 1.75 1.75 0 0 1 1.866 1.868z",
    className: "prefix__cls-7",
    "data-name": "Path 2559",
    transform: "translate(-103.323 -140.399)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2560",
    d: "M243.169 142.767a.287.287 0 0 1 .267.267v5.67c0 1.134-.934 1.868-2.268 1.868a9.688 9.688 0 0 1-1.868-.267c-.133-.067-.2-.133-.2-.267v-.067c0-.133.067-.2.067-.267.067-.133.133-.2.267-.2h.067a6.225 6.225 0 0 0 1.468.267c.934 0 1.334-.4 1.334-1v-1.134h-.067a2.133 2.133 0 0 1-1.267.467 2.35 2.35 0 0 1-2.468-2.6 2.518 2.518 0 0 1 2.468-2.8 2.471 2.471 0 0 1 1.468.467v-.133a.287.287 0 0 1 .267-.267h.467zm-.734 1.2a1.963 1.963 0 0 0-1.2-.467c-.934 0-1.534.8-1.534 2s.6 1.8 1.534 1.8a1.333 1.333 0 0 0 1.2-.6z",
    className: "prefix__cls-7",
    "data-name": "Path 2560",
    transform: "translate(-106.286 -140.432)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_2561",
    d: "M252.769 147.136c.133 0 .2.067.267.2l.067.2v.067c0 .133-.067.2-.2.267a6.67 6.67 0 0 1-1.8.334 2.509 2.509 0 0 1-2.6-2.8 2.543 2.543 0 0 1 2.6-2.8 2.1 2.1 0 0 1 2.2 2.335v.4a.287.287 0 0 1-.267.267H249.5a1.612 1.612 0 0 0 1.6 1.734 3.706 3.706 0 0 0 1.534-.334c.066.13.135.13.135.13zm-.4-2.335a1.265 1.265 0 0 0-1.267-1.4 1.546 1.546 0 0 0-1.534 1.534h2.8z",
    className: "prefix__cls-7",
    "data-name": "Path 2561",
    transform: "translate(-109.616 -140.399)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1afc1991806a943fb38e044c69593daf.svg";
export { ForwardRef as ReactComponent };